export default {
  ENV: 'development',
  ROOT_URL: 'http://localhost',
  // Local websocket: the dockerized Soketi (dev-infra) on the host, reached over
  // plain ws on 6001 with the Soketi default app key. PusherWebsocketSubscriber
  // falls back to TLS:true / port 80 / build-time PUSHER_KEY for every other
  // (deployed) environment, so non-local behaviour is unchanged.
  WS_URL: 'localhost',
  WS_PORT: 6001,
  WS_FORCE_TLS: false,
  // Must match the Soketi app key (dev-infra/.env SOKETI_DEFAULT_APP_KEY) and the
  // backend's PUSHER_APP_KEY (conversional-laravel/.env).
  PUSHER_KEY: '477552f8725de0898056',
  sentry: 'https://6a99474d26cb411395b5f81a07eba4c8@o236458.ingest.sentry.io/1452146',
  GA_ID: 'U-xxxxx',
  STUDIO_URL: 'http://localhost:3400/',
  COOKIES: {
    "tokens[refresh_token]": "DUMMY",
    "tokens[access_token]": "DUMMY",
  }
};
